import { Button, Card, CardContent, CardHeader, Divider, Grid, Stack, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { SnackbarContent } from "../../../components";
import { useGetMeetingsForTeam } from "../../../http";
import { useTeamPageLayoutContext } from "../TeamPageLayout";
import { CreateTeamMeetingModal, TeamMeetingsList } from "./components";

const TeamMeetingsPage = () => {
  const { team } = useTeamPageLayoutContext();
  const { isLoading: isLoadingMeetings, data } = useGetMeetingsForTeam(team?.guid);
  const [isCreateModalVisible, setIsCreateModalVisible] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  function handleMeetingCreated() {
    enqueueSnackbar(<SnackbarContent title="Meeting Created" />, {
      variant: "success",
    });
    setIsCreateModalVisible(false);
  }

  return (
    <>
      <Stack spacing={{ xs: 0.75, md: 1 }}>
        <Card>
          <CardContent>
            <Stack spacing={1} direction="row" alignItems="center" justifyContent="space-between">
              <Typography variant="h5">Meetings</Typography>
              {(team.isAdministrator || team.isMember) && (
                <Button variant="contained" onClick={() => setIsCreateModalVisible(true)}>
                  Create New Meeting
                </Button>
              )}
            </Stack>
          </CardContent>
        </Card>

        <Grid container sx={{ justifyContent: "center" }}>
          <Grid size={{ sm: 12, md: 8 }}>
            <Card>
              <CardHeader title={<Typography variant="h6">Team Meetings</Typography>} />
              <Stack>
                <Divider />
                <TeamMeetingsList isLoading={isLoadingMeetings} meetings={data?.meetings ?? []} />
              </Stack>
            </Card>
          </Grid>
        </Grid>
      </Stack>
      <CreateTeamMeetingModal
        visible={isCreateModalVisible}
        onCreated={handleMeetingCreated}
        onCancelled={() => setIsCreateModalVisible(false)}
      />
    </>
  );
};

export { TeamMeetingsPage };
